import React from "react";
import Footer from "../footer/Footer";
import Header from "../header/Header";
import VTUserDrinkHistory from "../page/VTUserDrinkHistory";

export default function LandingUserDrinkHistory() {
    return (
        <>
            <Header headerType="UserOnly"/>
            <VTUserDrinkHistory/>
            <Footer/>
        </>
    );
}